"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOverwolfGameBodySteamDataToJSON = exports.CreateOverwolfGameBodySteamDataFromJSONTyped = exports.CreateOverwolfGameBodySteamDataFromJSON = void 0;
var runtime_1 = require("../runtime");
function CreateOverwolfGameBodySteamDataFromJSON(json) {
    return CreateOverwolfGameBodySteamDataFromJSONTyped(json, false);
}
exports.CreateOverwolfGameBodySteamDataFromJSON = CreateOverwolfGameBodySteamDataFromJSON;
function CreateOverwolfGameBodySteamDataFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'shortDescription': !(0, runtime_1.exists)(json, 'shortDescription') ? undefined : json['shortDescription'],
        'genres': !(0, runtime_1.exists)(json, 'genres') ? undefined : json['genres'],
        'developers': !(0, runtime_1.exists)(json, 'developers') ? undefined : json['developers'],
        'publishers': !(0, runtime_1.exists)(json, 'publishers') ? undefined : json['publishers'],
        'releaseDate': !(0, runtime_1.exists)(json, 'releaseDate') ? undefined : json['releaseDate'],
        'headerImage': !(0, runtime_1.exists)(json, 'headerImage') ? undefined : json['headerImage'],
        'capsuleImage': !(0, runtime_1.exists)(json, 'capsuleImage') ? undefined : json['capsuleImage'],
        'capsuleImageV5': !(0, runtime_1.exists)(json, 'capsuleImageV5') ? undefined : json['capsuleImageV5'],
        'background': !(0, runtime_1.exists)(json, 'background') ? undefined : json['background'],
        'backgroundRaw': !(0, runtime_1.exists)(json, 'backgroundRaw') ? undefined : json['backgroundRaw'],
        'website': !(0, runtime_1.exists)(json, 'website') ? undefined : json['website'],
    };
}
exports.CreateOverwolfGameBodySteamDataFromJSONTyped = CreateOverwolfGameBodySteamDataFromJSONTyped;
function CreateOverwolfGameBodySteamDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'description': value.description,
        'shortDescription': value.shortDescription,
        'genres': value.genres,
        'developers': value.developers,
        'publishers': value.publishers,
        'releaseDate': value.releaseDate,
        'headerImage': value.headerImage,
        'capsuleImage': value.capsuleImage,
        'capsuleImageV5': value.capsuleImageV5,
        'background': value.background,
        'backgroundRaw': value.backgroundRaw,
        'website': value.website,
    };
}
exports.CreateOverwolfGameBodySteamDataToJSON = CreateOverwolfGameBodySteamDataToJSON;
